import { apiClient } from './apiClient';

export interface AppointmentTypeShare {
    id: string;
    appointmentTypeId: string;
    userId: string;
    userEmail: string;
    userFullName: string;
    canWrite: boolean;
    createdAt: string;
}

export interface CreateAppointmentTypeShareDto {
    userEmail: string;
    canWrite: boolean;
}

export interface UpdateAppointmentTypeShareDto {
    canWrite: boolean;
}

class AppointmentTypeShareService {
    async getShares(appointmentTypeId: string): Promise<AppointmentTypeShare[]> {
        try {
            const response = await apiClient.get<AppointmentTypeShare[]>(`/appointment-types/${appointmentTypeId}/shares`);
            return response.data;
        } catch (error) {
            console.error('Error fetching appointment type shares:', error);
            throw error;
        }
    }

    async createShare(appointmentTypeId: string, dto: CreateAppointmentTypeShareDto): Promise<AppointmentTypeShare> {
        try {
            const response = await apiClient.post<AppointmentTypeShare>(`/appointment-types/${appointmentTypeId}/shares`, dto);
            return response.data;
        } catch (error) {
            console.error('Error creating appointment type share:', error);
            throw error;
        }
    }

    async updateShare(appointmentTypeId: string, shareId: string, dto: UpdateAppointmentTypeShareDto): Promise<AppointmentTypeShare> {
        try {
            const response = await apiClient.put<AppointmentTypeShare>(`/appointment-types/${appointmentTypeId}/shares/${shareId}`, dto);
            return response.data;
        } catch (error) {
            console.error('Error updating appointment type share:', error);
            throw error;
        }
    }

    async deleteShare(appointmentTypeId: string, shareId: string): Promise<void> {
        try {
            await apiClient.delete(`/appointment-types/${appointmentTypeId}/shares/${shareId}`);
        } catch (error) {
            console.error('Error deleting appointment type share:', error);
            throw error;
        }
    }
}

export const appointmentTypeShareService = new AppointmentTypeShareService(); 